import * as fromDatatype from '../datatype-library/index';

export interface bl_aat_claim_ocr_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_ocr_scanned_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  algorithm_provider: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  claim_ocr_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_ocr_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
  res_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  res_ocr_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_ocr_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_confidence_level: fromDatatype.NumericDatatypeInterface;
  res_verification_status: fromDatatype.VarcharDatatypeInterface;
  res_amount_txn: fromDatatype.MoneyDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  doc_source_channel: fromDatatype.VrsnDataFieldInterface;
  rejection_reason: fromDatatype.TextDatatypeInterface;
  claim_doc_line_guid: fromDatatype.VarcharDatatypeInterface;
  amount_sst: fromDatatype.NumericDatatypeInterface;
  amount_excl_sst: fromDatatype.NumericDatatypeInterface;
  claim_ocr_company_name: fromDatatype.VarcharDatatypeInterface;
}

export class bl_aat_claim_ocr_doc_hdr_RowClass implements bl_aat_claim_ocr_doc_hdr_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  claim_ocr_scanned_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
  algorithm_provider: fromDatatype.VarcharDatatypeInterface;
  txn_type: fromDatatype.VarcharDatatypeInterface;
  txn_code: fromDatatype.VarcharDatatypeInterface;
  txn_date: fromDatatype.TimestampTzDatatypeInterface;
  claim_ocr_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  claim_ocr_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  confidence_level: fromDatatype.NumericDatatypeInterface;
  verification_status: fromDatatype.VarcharDatatypeInterface;
  amount_txn: fromDatatype.MoneyDatatypeInterface;
  server_doc_1: fromDatatype.VarcharDatatypeInterface;
  server_doc_type: fromDatatype.VarcharDatatypeInterface;
  client_doc_type: fromDatatype.VarcharDatatypeInterface;
  login_subject_guid: fromDatatype.GuidDataFieldInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  membership_hdr_guid: fromDatatype.GuidDataFieldInterface;
  website_hdr_guid: fromDatatype.GuidDataFieldInterface;
  posting_status: fromDatatype.VarcharDatatypeInterface;
  posting_membership: fromDatatype.VarcharDatatypeInterface;
  res_txn_date: fromDatatype.TimestampTzDatatypeInterface;
  res_ocr_branch_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_ocr_company_hdr_guid: fromDatatype.GuidDataFieldInterface;
  res_confidence_level: fromDatatype.NumericDatatypeInterface;
  res_verification_status: fromDatatype.VarcharDatatypeInterface;
  res_amount_txn: fromDatatype.MoneyDatatypeInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  created_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  updated_by_subject_guid: fromDatatype.VarcharDatatypeInterface;
  status: fromDatatype.StatusDataFieldInterface;
  revision: fromDatatype.RevisionDataFieldInterface;
  vrsn: fromDatatype.VrsnDataFieldInterface;
  doc_source_channel: fromDatatype.VrsnDataFieldInterface;
  rejection_reason: fromDatatype.TextDatatypeInterface;
  claim_doc_line_guid: fromDatatype.VarcharDatatypeInterface;
  amount_sst: fromDatatype.NumericDatatypeInterface;
  amount_excl_sst: fromDatatype.NumericDatatypeInterface;
  claim_ocr_company_name: fromDatatype.VarcharDatatypeInterface;
}
